import type { AxiosRequestConfig } from "axios";
import { api } from "./axios";

export const get = async <T>(url: string, config?: AxiosRequestConfig) => {
  const response = await api.get<T>(url, config);
  return response.data;
};

export const post = async <T, B = unknown>(
  url: string,
  body?: B,
  config?: AxiosRequestConfig
) => {
  const response = await api.post<T>(url, body, config);
  return response.data;
};

export const put = async <T, B = unknown>(
  url: string,
  body?: B,
  config?: AxiosRequestConfig
) => {
  const response = await api.put<T>(url, body, config);
  return response.data;
};

export const patch = async <T, B = unknown>(
  url: string,
  body?: B,
  config?: AxiosRequestConfig
) => {
  const response = await api.patch<T>(url, body, config);
  return response.data;
};

export const del = async <T>(url: string, config?: AxiosRequestConfig) => {
  const response = await api.delete<T>(url, config);
  return response.data;
};
